<template>
  <div>
    <div style="display: flex;align-content: space-between;align-items: center;">
      <div class="title" style="flex:1;">
        <h3 v-if="!this.$route.meta.active">{{$t('dashboard.subscriptions.title')}}</h3>
        <h3 v-if="this.$route.meta.active">{{$t('dashboard.subscriptions.title_active')}}</h3>
      </div>
      <div v-if="this.$route.meta.active" style="flex:1;text-align: right;">
        <router-link
          class="see-all-subscriptions-button"
          :to="{name: 'subscriptions_history'}">
          {{ $t('dashboard.subscriptions.see_all_subscriptions') }}
        </router-link>
      </div>
    </div>
    <ResourceTable
      :resource="SubscriptionsHistoryTable.resource"
      :params="SubscriptionsHistoryTable.options"
      :perPage="per_page"
      :reloadListener="'loadSubscriptions'"
      class="subscriptions-history-table"
    >
      <template slot="header">
        <th>
          {{$t('dashboard.subscriptions.table.date_start')}}
        </th>
        <th>
          {{$t('dashboard.subscriptions.table.date_end')}}
        </th>
        <th>
          {{$t('dashboard.subscriptions.table.webstar')}}
        </th>
        <th>
          {{$t('dashboard.subscriptions.table.auto_renew_status')}}
        </th>
        <th>
          {{$t('dashboard.subscriptions.table.actions')}}
        </th>
      </template>
      <template slot-scope="{element}">
        <td style="text-align: center;">
          {{$d(new Date(element.created_at), 'short')}}
        </td>
        <td style="text-align: center;">
          {{$d(new Date(element.next_scheduled_payment.date), 'short')}}
        </td>
        <td>
          {{element.subscription_plan.data.description}}
        </td>
        <td style="text-align: center;">
          {{$t(`payment_status.${element.latest_payment_status}`)}}
        </td>
        <td class="text-center">
          <div style="display: flex;">
            <router-link
              class="buy_tokens_button"
              :to="{name: 'subscription.payments', params: {subscription: element.id}}">
                <button
                  :title="$t(`subscription.recurrency.view_payments`)"
                >
                  💳
                </button>
            </router-link>
            <button
              v-if="element.active"
              class="cancel"
              :title="$t(`subscription.recurrency.cancel_subscription`)"
              @click="unsubscribeSubscription = element"
            >
              ✖
            </button>
            <button
              v-else
              class="info"
              :title="$t(`subscription.recurrency.canceled_subscription`)"
            >
            ⓘ
          </button>
          </div>
        </td>
      </template>
      <template slot="responsive_card_{element}" slot-scope="{element}">
        <div class="card">
          <div style="display: flex;margin:1rem 0;align-items: center;">
            <div style="flex: 1">{{$d(new Date(element.created_at), 'short')}} - {{$d(new Date(element.next_scheduled_payment.date), 'short')}}</div>
            <div style="border-radius:0.5rem;padding: 0.3rem 0.5rem;font-weight: bold;font-size: 0.9rem;" :class="element.latest_payment_status">{{$t(`payment_status.${element.latest_payment_status}`)}}</div>
          </div>
          <div>{{element.subscription_plan.data.description}}</div>
          <div style="display: flex;margin:1rem 0;align-items: center;">
            <div style="flex: 1;">{{element.user_credit_card.data.last_4_digits ? 'XXXX-'+element.user_credit_card.data.last_4_digits : '-'}} {{element.user_credit_card.data.type}}</div>
            <div class="amount">${{Number.parseFloat(element.subscription_plan.data.amount).toFixed(2)}}</div>
          </div>
          <div>
            <router-link
              class="buy_tokens_button"
              :to="{name: 'subscription.payments', params: {subscription: element.id}}">
                <button
                  :title="$t(`subscription.recurrency.view_payments`)"
                >
                  💳 {{$t(`subscription.recurrency.view_payments`)}}
                </button>
            </router-link>
            <button
              v-if="element.active"
              class="cancel"
              :title="$t(`subscription.recurrency.cancel_subscription`)"
              @click="unsubscribeSubscription = element"
            >
              ✖ {{$t(`subscription.recurrency.cancel_subscription`)}}
            </button>
            <div
              v-else
              class="cancel"
            >
              {{$t(`subscription.recurrency.canceled_subscription`)}}
            </div>
          </div>
        </div>
      </template>
      <template slot="empty">
        {{$t('noRecords')}}
      </template>
    </ResourceTable>
    <UnsubscribeModal
      v-if="unsubscribeSubscription"
      :subscription="unsubscribeSubscription"
      @updated="handleUnsubscribeUpdated"
      @cancel="unsubscribeSubscription = null"
    />
  </div>
</template>
<script>
import ResourceTable from "../components/ResourceTable"
import resources from "../resources";
import UnsubscribeModal from "./UnsubscribeModal";
import EventBus from "../eventbus";

export default {
  name: 'TokenTransactionsTable',
  components: {ResourceTable, UnsubscribeModal},
  computed: {
    SubscriptionsHistoryTable(){
      let data = {
        resource: resources.subscriptions,
        options: {
          order_by: [['created_at', 'desc']],
          user_id: this.$auth.user().id,
          times_loaded: this.times_loaded
        }
      };
      if(this.$route.meta.active) {
        data.options.active = this.$route.meta.active;
      }
      return data;
    }
  },
  data(){
    return {
      subscriptions: null,
      loading: true,
      error: false,
      unsubscribeSubscription: null,
      times_loaded: 0,
      per_page: process.env.VUE_APP_PER_PAGE
    };
  },
  methods: {
    handleUnsubscribeUpdated(){
      this.unsubscribeSubscription = null;
      EventBus.$emit('loadSubscriptions');
    }
  }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';
.subscriptions-history-table {
  display: block;

  .table-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
  
    th.header {
      background-color: var(--pallete_main_color);
      color: var(--pallete_clear_text_color);
      text-transform: uppercase;
      font-weight: bold;
      text-align: left;
    }
    
    td {
      font-size: .9em;
    
      &.text-center {
        text-align: center;
      }
    
      button {
        margin: 5px;
        padding: 5px 15px;
        border-radius: 3px;
        cursor: pointer;
        transition: background-color 200ms ease-in-out;
        font-size: 1.2em;
      
        &.cancel {
          background-color: var(--pallete_main_color);
          color: #ffffff;
        
          &:hover {
            background-color: #fd4872;
          }
        }

        &.info {
          // cyan
          background-color: #287abf;
          color: #ffffff;
          cursor: help;
          font-weight: bold;
        }
      }
    }
  }
  
  .failed-wrapper {
      text-align: center;
      padding: 1em;
  }

  .failed-wrapper, .loading-wrapper{
      min-height: 75px;
  }
}

.see-all-subscriptions-button {  
  &:hover {
    font-weight: bold;
  }
}

.card {
  border-radius: 1rem;
  margin-bottom: 1rem;
  background-color: #131111;
  padding: 0.5rem 1rem;
  box-shadow: inset #ff4545 0px 0px 5px 0px;
  box-shadow: inset #000000 0px 0px 4px 0px;
  background-color: rgba(125, 125, 125, 0.5);
  font-weight: bold;

  & .amount {
    background-color:#454545;
    border-radius:0.5rem;
    padding: 0.3rem 0.5rem;
    font-weight: bold;
    font-size: 0.9rem;
    background-color: black;
  }

  & .canceled {
    background-color: red;
  }

  & .pending {
    background-color: orange;
  }

  & .approved {
    background-color: green;
  }

  button {
    margin: 5px 0;
    padding: 5px 15px;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    font-size: 0.9rem;
    width: 100%;
    box-sizing: border-box;

    &.cancel {
      background-color: var(--pallete_main_color);
      color: #ffffff;
    
      &:hover {
        background-color: #fd4872;
      }
    }
  }

  div.cancel {
    margin: 5px 0;
    padding: 5px 15px;
    border-radius: 3px;
    font-size: 0.9rem;
    width: 100%;
    box-sizing: border-box;
    text-align: center;

    color: red;
  }
}
</style>